module.exports = __webpack_public_path__ + "img/signature-bleuSaphir.c10df617.png";